







import store from '@/store';

export default
  name: 'ActiveButton'

  props:
    # ラベル
    label:
      type: String
      default: ''

  # click: クリックイベント
  methods: {
    click: (e) ->
      @$emit('click')
  }
